import SignupReducer from "./components/pages/public/signup/signup.reducer";

export default {
  signup: SignupReducer
}